import { Offer_Offer as os, 
    Offer_OfferData as offerData,
    Offer_GetAvailableThemes as themes,
    Offer_GetAvailableCountries as countries,
    Offer_OfferBySlug as offerBySlug,
    Offer_TravelDeals as deals,
    Offer_Promotion as prom,
    Offer_OfferByVariantId as obyv,
    Offer_OfferByContactSlug as contact } from "./backend"

const getOffer = async (id) => {
    let { data } =  await os({
        id: id
    });
    return data;
}

const getOfferByVariantId = async (variantId) => {
    let { data } =  await obyv({
        id: variantId
    });
    return data;
}

const getOfferForContact = async (slug, page, pageSize) => {
    let { data } =  await contact({
        slug: slug,
        page: page,
        pageSize: pageSize
    });
    return data;
}

const getOfferBySlug = async (slug) => {
    let { data } =  await offerBySlug({
        slug: slug
    });
    return data;
}

const getOffersWithDealPromotion = async () => {
    let { data } =  await deals();
    return data;
}

const getOffersWithCustomPromotion = async (promotion) => {
    let { data } =  await prom({name: promotion});
    return data;
}

const getOfferData = async (id) => {
    let { data } =  await offerData({
        id: id,
        $config: {
            _silent: true
        }
    });
    if(data && data.texts && data.texts.length > 0 ){
          data.texts = data.texts.sort((a,b) => {
            if(a.position && b.position){
                if (a.position < b.position) return -1
                if (a.position > b.position) return 1
              }
              return 0
          });
    }
    return data;
}

const getThemesForMenu = async () => {
    let res = await themes();
    return res.data;
}


const getCountriesForMenu = async () => {
    let { data } = await countries();
    return data;
}

const getMenu = async() => {
    return {
        countries: await getCountriesForMenu(),
        themes: await getThemesForMenu()
    }
}

export default {
    getOffer,
    getMenu,
    getOfferData,
    getOfferBySlug,
    getOffersWithDealPromotion,
    getOfferByVariantId,
    getOfferForContact,
    getOffersWithCustomPromotion
}